import { useEffect, useRef, useState } from "react";
import LoadingScreen from "../../components/LoadingScreen";
import { MinusCircleIcon } from "@heroicons/react/24/solid";
import { OpeningWarehouseProduct } from "../../interfaces/OpeningWarehouseProduct";
import { setLike } from "../../stores/slices/openingWarehouseSlice";
import {
  addItemToLocalStorageArray,
  loadArrayFromLocalStorage,
  localStorageKeys,
  removeItemFromLocalStorageArray,
  StorageModel,
} from "../../utils/localStorage";
import { useDispatch } from "react-redux";
import {
  changeHeaderFilter,
  convertFilterIcon,
} from "../../utils/headerFilter";
import { getData } from "../../apis";
import { API } from "../../apis/config";
// import map from "../../assets/images/opening_warehouse_map.jpg";

function LikeProduct() {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<OpeningWarehouseProduct[]>([]);
  const dispatch = useDispatch();
  const inputRefs = useRef<HTMLInputElement[]>([]);
  const [sortedData, setSortedData] = useState<OpeningWarehouseProduct[]>([]);
  const [headerFilter] = useState<{ [key: string]: number }>({});

  // const calculateVolume = (
  //   key: keyof OpeningWarehouseProduct,
  //   key2: keyof OpeningWarehouseProduct
  // ): number => {
  //   if (data === undefined) return 0;
  //   return data.reduce((acc, item) => {
  //     const value = item[key];
  //     const value2 = item[key2];
  //     if (typeof value === "number" && typeof value2 === "number") {
  //       return acc + value * value2;
  //     }
  //     return acc; // 값이 number가 아닐 경우 더하지 않음
  //   }, 0);
  // };

  // const separateFirstLetter = (target: string): string => {
  //   const separators = ["[세트]"];
  //   const name = target.replaceAll(" ", "");
  //   let firstLetter = name.at(0);
  //   separators.forEach((separator) => {
  //     if (name.includes(separator)) {
  //       firstLetter = name.split(separator)[1].at(0);
  //     }
  //   });
  //   return firstLetter ?? "";
  // };

  // const calculateLetter = (key: keyof OpeningWarehouseProduct): number => {
  //   return new Set(
  //     data.map((item) => {
  //       return separateFirstLetter(item[key].toString());
  //     })
  //   ).size;
  // };

  useEffect(() => {
    const data = async () => {
      const p = loadArrayFromLocalStorage(localStorageKeys.likeProduct);
      await getData<OpeningWarehouseProduct[]>(API.OPENING_WAREHOUSE.PRODUCTS)
        .then((res) => {
          let filtered_rst = res.result.filter((model) =>
            p.some((rst) => rst.id === model.id)
          );

          // id가 일치하는 모델의 quantity 값을 수정
          filtered_rst.forEach((model) => {
            const matchingRst = p.find((rst) => rst.id === model.id);
            if (matchingRst) {
              model.quantity = matchingRst.quantity; // 원하는 값으로 수정
              model.isLike = matchingRst.isLike;
            }
          });

          setData(filtered_rst);
          setSortedData(filtered_rst);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };
    data();
  }, []);

  const handleClick = (row: OpeningWarehouseProduct) => {
    const newRow = { ...row, isLike: !row.isLike };
    if (row.isLike) {
      removeItemFromLocalStorageArray(localStorageKeys.likeProduct, newRow.id);
    } else {
      addItemToLocalStorageArray(localStorageKeys.likeProduct, {
        id: newRow.id,
        isLike: newRow.isLike,
        quantity: newRow.quantity,
      });
    }

    const p = data.filter(
      (item) => item.id !== newRow.id && item.isLike === true
    );
    setData(p);
    setSortedData(p);

    dispatch(setLike(newRow.id));
  };

  const clickHeader = (
    key: string,
    compareFn: (
      a: OpeningWarehouseProduct,
      b: OpeningWarehouseProduct
    ) => number
  ) => {
    changeHeaderFilter(headerFilter, setSortedData, key, compareFn, data);
  };

  const createFilterIcon = (key: string): string => {
    return convertFilterIcon(headerFilter, key);
  };

  return (
    <div className="md:mx-20">
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <div>
          <table className="mt-4 min-w-full bg-white text-xs md:text-base">
            <thead className="bg-gray-200  ">
              <tr>
                <th className="w-1/12 md:px-4 px-2 py-2 text-center text-gray-600">
                  수량
                </th>
                <th
                  className="md:w-1/3 w-1/2 px-4 py-2 text-center text-gray-600 cursor-pointer"
                  onClick={() => {
                    clickHeader("name", (a, b) =>
                      a.name.localeCompare(b.name, "ko")
                    );
                  }}
                >
                  상품명{createFilterIcon("name")}
                </th>
                <th
                  className="w-3/12 px-4 py-2 text-center text-gray-600 cursor-pointer"
                  onClick={() => {
                    clickHeader("location", (a, b) =>
                      a.location.localeCompare(b.location, "ko")
                    );
                  }}
                >
                  위치{createFilterIcon("location")}
                </th>
                <th className="w-1/12 md:px-4 px-0 py-2 text-center text-gray-600">
                  제외
                </th>
              </tr>
            </thead>
            <tbody className="text-base">
              {sortedData
                .slice()
                .reverse()
                .map((item, key) => (
                  <tr className="border-t" key={key}>
                    <td>
                      <input
                        type="number"
                        value={item.quantity}
                        className="w-full text-center text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        ref={(el) =>
                          (inputRefs.current[key] = el as HTMLInputElement)
                        }
                        onClick={(e) => {
                          if (inputRefs.current[key]) {
                            inputRefs.current[key].focus();
                            inputRefs.current[key].select();
                          }
                        }}
                        onChange={(e) => {
                          const localStorageData: StorageModel[] =
                            loadArrayFromLocalStorage(
                              localStorageKeys.likeProduct
                            );

                          // localstorage 에서 저장된 id로 검색
                          const target = data.find(
                            (e) =>
                              e.id ===
                              localStorageData.find(
                                (localStorageData) =>
                                  localStorageData.id === item.id
                              )?.id
                          );

                          const quantity = Number(e.target.value);
                          if (target && quantity > 0) {
                            target.quantity = quantity;
                            const p = data.map((item) => {
                              if (item.id === target.id) {
                                return target;
                              } else {
                                return item;
                              }
                            });
                            setData(p);
                            setSortedData(p);
                            removeItemFromLocalStorageArray(
                              localStorageKeys.likeProduct,
                              target.id
                            );
                            addItemToLocalStorageArray(
                              localStorageKeys.likeProduct,
                              {
                                id: target.id,
                                isLike: target.isLike,
                                quantity: target.quantity,
                              }
                            );
                          }
                        }}
                      />
                    </td>
                    <td className="px-4 py-2 text-sm md:text-base">
                      {item.name}
                    </td>
                    <td className="px-4 py-2 text-sm md:text-base">
                      {item.location}
                    </td>
                    <td className="px-4 py-2 ">
                      <button onClick={() => handleClick(item)}>
                        <MinusCircleIcon
                          className={`h-6 w-6 ${
                            item.isLike ? "text-red-500" : "text-black"
                          }`}
                        />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

          {/* <div className="flex items-center justify-center mt-5">
            <img src={map} alt="map" className="rounded-lg" />
          </div> */}
        </div>
      )}
    </div>
  );
}

export default LikeProduct;
